import { permissionGuard } from './permission.guard';

/**
 * Fund reports read every submission of a fund, so the route needs the same view-all flag the
 * backend's reports endpoint checks.
 */
export const reportingGuard = permissionGuard((p) => p.canViewAll());
